import { captureMessage } from 'conversations/utils/logRocket'
import { ConversationNotification } from 'shared/notifications/ConversationNotification'

import { RootAction } from 'typesafe-actions'

export interface AppServices {
  notifications: NotificationService
  badges: BadgeService
  auth: AuthService
  util: UtilService
  reload: ReloadService
  redux: ReduxService
}

export interface NotificationService {
  sendNotification: (notification: ConversationNotification) => Promise<void>
}

export interface BadgeService {
  showBadgeIconNumber: (numberOfUnreadConversations: number) => Promise<void>
  isWindowVisible: () => Promise<boolean>
}

export interface AuthService {
  openWebLogin: () => void
  logout: () => void
}

export interface UtilService {
  log: (entry: any) => void
}

export interface ReloadService {
  reloadApplication: () => void
}

let appServices: AppServices
export const registerAppServices = (services: AppServices): void => {
  appServices = services
}

export const getAppServices = (): AppServices => {
  if (!appServices) {
    captureMessage('Conversation App services not yet registered')
    throw new Error('Conversation App services not yet registered')
  }

  return appServices
}

export interface ReduxService {
  sendAction: (action: RootAction) => void
}
